import React from "react";
import { PublicShell } from "./PublicShell";
import { SITE } from "@/constants/site";

export default function Refund() {
  return (
    <PublicShell
      title="Kebijakan Refund"
      subtitle="Prosedur pengembalian dana kepada pelanggan."
    >
      <p>
        {SITE.name} berkomitmen memberikan layanan pembayaran yang transparan dan
        adil. Kebijakan ini mengatur prosedur pengembalian dana (refund) atas transaksi
        yang dilakukan melalui {SITE.serviceName}.
      </p>

      <h2>1. Kondisi yang Dapat Diajukan Refund</h2>
      <ul>
        <li>Pembayaran ganda (dobel) untuk tagihan atau item yang sama.</li>
        <li>Kesalahan nominal akibat gangguan sistem yang dapat dibuktikan.</li>
        <li>Dana terpotong namun transaksi tidak tercatat/gagal diproses.</li>
        <li>Pembayaran atas tagihan yang telah dibatalkan oleh pihak pesantren.</li>
      </ul>

      <h2>2. Kondisi yang Tidak Dapat Direfund</h2>
      <ul>
        <li>Tagihan yang sudah jatuh tempo dan telah digunakan/dialokasikan sesuai peruntukannya.</li>
        <li>Kesalahan input nominal oleh pengguna yang telah dikonfirmasi dan berhasil.</li>
        <li>Saldo tabungan santri — pengembaliannya mengikuti mekanisme penarikan tabungan, bukan refund.</li>
      </ul>

      <h2>3. Cara Mengajukan Refund</h2>
      <ol>
        <li>
          Hubungi kami melalui email{" "}
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a> atau WhatsApp{" "}
          <a href={`https://wa.me/${SITE.phoneRaw}`} target="_blank" rel="noreferrer">
            {SITE.phone}
          </a>{" "}
          ({SITE.waName}).
        </li>
        <li>Sertakan bukti transaksi (struk/screenshot), nama santri, tanggal, dan nominal.</li>
        <li>Jelaskan alasan pengajuan refund secara jelas.</li>
      </ol>

      <h2>4. Proses & Waktu Pengembalian</h2>
      <ul>
        <li>Pengajuan akan diverifikasi dalam <strong>1–3 hari kerja</strong>.</li>
        <li>
          Jika disetujui, dana dikembalikan ke sumber pembayaran / rekening yang disepakati
          dalam <strong>3–14 hari kerja</strong>, tergantung metode pembayaran dan penyedia
          payment gateway.
        </li>
        <li>Pengelola akan menginformasikan hasil verifikasi kepada pengaju.</li>
      </ul>

      <h2>5. Biaya</h2>
      <p>
        Pengembalian dana dilakukan sesuai nominal yang sah. Biaya administrasi payment
        gateway (jika ada dan tidak dapat dikembalikan oleh penyedia) akan diinformasikan
        secara transparan kepada pengaju.
      </p>

      <h2>6. Hubungi Kami</h2>
      <p>
        Untuk pertanyaan atau pengajuan refund, hubungi{" "}
        <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.
      </p>
    </PublicShell>
  );
}
